<div class="menu dark-background">
  <nav>
    <div class="container menu__content">
      <div class="menu__intro text" [innerHTML]="markdown"></div>
      <app-menu-items [menuItems]="menuItems"></app-menu-items>
    </div>
  </nav>
</div>
